<template>
  <v-app class="app-root" v-if="userAuth">
    <link
      rel="stylesheet"
      href="https://w2.registrucentras.lt/savitarna/css/print.css"
      type="text/css"
      media="print"
    />
    <template v-if="userSutikimas">
      <el-overlay-loading :loading="!loadedSavitarna" />
      <sav-toolbar class="app--toolbar" @loaded="loadedToolbar = true" />
      <v-main class="savitarna-main">
        <div class="savitarna-content-wrapper">
          <v-sheet class="d-flex">
            <div class="savitarna-content-left">
              <sav-left-menu @loaded="loadedMenu = true" />
            </div>
            <div class="savitarna-content-info" v-if="loadedSavitarna">
              <sav-breadcrumbs class="ma-0 pa-0" />
              <el-sistema-info savitarna />
              <router-view class="pa-0 mb-1" />
            </div>
          </v-sheet>
        </div>
        <!-- App Footer -->
        <sav-footer />
      </v-main>
      <!-- Go to top -->
      <app-fab />
    </template>
    <modal-savitarna-sutartis
      v-model="showSutartisModal"
      :loading="loading"
      @confirmSutartis="confirmSutartis"
      @cancelSutartis="cancelSutartis"
    />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import checkUser from '@/mixins/checkUser'
import SavToolbar from '@/components/layouts/savitarna/SavToolbar'
import SavLeftMenu from '@/components/layouts/savitarna/SavLeftMenu'
import SavBreadcrumbs from '@/components/layouts/savitarna/SavBreadcrumbs'
import SavFooter from '@/components/layouts/savitarna/SavFooter'
import AppFab from '@/components/layouts/turtas/AppFab'
import ModalSavitarnaSutartis from '@/components/modals/ModalSavitarnaSutartis'

export default {
  name: 'LayoutSavitarna',
  components: {
    SavToolbar,
    SavLeftMenu,
    SavBreadcrumbs,
    SavFooter,
    AppFab,
    ModalSavitarnaSutartis,
  },
  mixins: [checkUser],
  data() {
    return {
      userAuth: false,
      loadedToolbar: false,
      loadedMenu: false,
      loading: false,
      // showSutartisModal: false,
    }
  },
  computed: {
    ...mapGetters(['userID', 'savitarnaHomeUrl', 'userSutikimas']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    loadedSavitarna() {
      return this.loadedToolbar && this.loadedMenu
    },
    showSutartisModal: {
      set(value) {
        //
      },
      get() {
        return !this.userSutikimas
      },
    },
  },
  watch: {
    isAppIdle(val) {
      if (val) {
        if (!this.isLocal) {
          this.$store.dispatch('unlockObj')
          window._VMA.$emit('SAV_SESSION_ERROR')
        }
      }
    },
  },
  created() {
    this.handleMetaData()
    this.checkSavitarna()
    this.$store.dispatch('unlockObj')
  },
  methods: {
    checkSavitarna() {
      if (this.isLocal) {
        this.checkUser()
        return
      }
      this.checkUserSavitarna()
    },
    confirmSutartis() {
      // this.$store.dispatch('savitarnaSutartis', true)
      this.loading = true

      let data = {
        snau_id: this.userID,
        snau_sutikimas_su_salygomis: true,
      }
      this.$axios
        .post(`naudotojas/sutikimas`, data)
        .then(res => {
          this.$store.dispatch('userSutikimas', true)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelSutartis() {
      window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=1`
      //window.history.go(-1)
    },
    handleMetaData() {
      const favicon = document.getElementById('favicon')
      favicon.href = `${process.env.VUE_APP_SAVITARNA_URL}faviconRC.ico`
      const title = document.getElementById('appTitle')
      title.innerHTML = 'VĮRC Savitarna'
    },
  },
}
</script>

<style lang="scss" scoped>
.app-root {
  background: #fff;
}
.savitarna-content-wrapper {
  width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding: 0 10px 0 10px !important;
}
.savitarna-content-left {
  width: 220px;
  padding: 0;
}
.savitarna-content-info {
  min-height: calc(100vh - 120px - 200px);
  min-width: 760px;
  width: calc(100% - 220px - 32px);
  margin-left: 32px;
  padding: 0;
  background: none;
}
</style>
